var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560 880 c0 -19 7 -20 137 -20 l138 0 -134 -134 -135 -135 -29 21 c-36 26 -109 48 -157 48 -150 0 -280 -130 -280 -280 0 -160 146 -293 305 -277 97 10 178 65 221 150 46 89 42 198 -11 278 l-23 36 134 134 134 134 0 -138 c0 -130 1 -137 20 -137 19 0 20 7 20 170 l0 170 -170 0 c-163 0 -170 -1 -170 -20z m-97 -276 c85 -29 157 -132 157 -224 0 -124 -116 -240 -240 -240 -124 0 -240 116 -240 240 0 63 23 114 75 165 72 73 152 92 248 59z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.89a43bfb.svg";
export { ForwardRef as ReactComponent };